// Generated by scripts/make-animated-catalog.py from the LimeZu animated pack. Do not edit.
import type { AnimatedSheet } from './animated-sheets.js';

export const GENERATED_ANIMATED_SHEETS: Readonly<Record<string, AnimatedSheet>> = {
  amplifier: { width: 1, height: 2, frames: 3, fps: 10 },
  amplifier_big: { width: 1, height: 3, frames: 3, fps: 10 },
  animeted_mirror_person_approaching: { width: 1, height: 2, frames: 12, fps: 6 },
  animeted_mirror_person_approaching_2: { width: 1, height: 2, frames: 12, fps: 6 },
  bathroom_cabinet_blue_empty: { width: 1, height: 2, frames: 10, fps: 6 },
  bathroom_cabinet_blue_full: { width: 1, height: 2, frames: 10, fps: 6 },
  bathroom_cabinet_white_empty: { width: 1, height: 2, frames: 10, fps: 6 },
  bathroom_cabinet_white_full: { width: 1, height: 2, frames: 10, fps: 6 },
  bathroom_cabinet_whiteblue_empty: { width: 1, height: 2, frames: 10, fps: 6 },
  bathroom_cabinet_whiteblue_full: { width: 1, height: 2, frames: 10, fps: 6 },
  bathroom_sink_2_new_3_10_loop: { width: 2, height: 2, frames: 14, fps: 10 },
  bathroom_sink_new_3_10_loop: { width: 2, height: 2, frames: 14, fps: 10 },
  bathtub: { width: 2, height: 4, frames: 4, fps: 10 },
  bathtub_2: { width: 2, height: 3, frames: 4, fps: 10 },
  bathtub_2_new_1_4_7_loop: { width: 2, height: 4, frames: 12, fps: 7 },
  bathtub_2_new_2_4_7_loop: { width: 2, height: 4, frames: 12, fps: 7 },
  bathtub_2_new_3_4_7_loop: { width: 2, height: 4, frames: 12, fps: 7 },
  bathtub_3_new_4_7_loop: { width: 2, height: 4, frames: 12, fps: 10 },
  bathtub_new_2_6_9_loop: { width: 2, height: 3, frames: 14, fps: 10 },
  bathtub_new_6_9_loop: { width: 2, height: 3, frames: 14, fps: 10 },
  bathtub_with_duck: { width: 2, height: 4, frames: 5, fps: 10 },
  blood_altar: { width: 3, height: 4, frames: 6, fps: 10 },
  butterfly: { width: 1, height: 1, frames: 4, fps: 10 },
  butterfly_2: { width: 1, height: 1, frames: 4, fps: 10 },
  butterfly_2_idle: { width: 1, height: 1, frames: 4, fps: 2 },
  butterfly_3: { width: 1, height: 1, frames: 4, fps: 10 },
  butterfly_3_idle: { width: 1, height: 1, frames: 4, fps: 2 },
  butterfly_4: { width: 1, height: 1, frames: 4, fps: 10 },
  butterfly_4_idle: { width: 1, height: 1, frames: 4, fps: 2 },
  butterfly_5: { width: 1, height: 1, frames: 4, fps: 10 },
  butterfly_5_idle: { width: 1, height: 1, frames: 4, fps: 2 },
  butterfly_6: { width: 1, height: 1, frames: 4, fps: 10 },
  butterfly_6_idle: { width: 1, height: 1, frames: 4, fps: 2 },
  butterfly_idle: { width: 1, height: 1, frames: 4, fps: 2 },
  candle_red_left: { width: 1, height: 2, frames: 3, fps: 10 },
  candle_red_right: { width: 1, height: 2, frames: 3, fps: 10 },
  candle_wax: { width: 1, height: 2, frames: 3, fps: 10 },
  canteen_big_fridge_cake: { width: 2, height: 3, frames: 14, fps: 6 },
  canteen_big_fridge_cake_left: { width: 2, height: 3, frames: 14, fps: 6 },
  canteen_big_fridge_empty: { width: 2, height: 3, frames: 14, fps: 6 },
  canteen_big_fridge_empty_left: { width: 2, height: 3, frames: 14, fps: 6 },
  canteen_counter: { width: 1, height: 3, frames: 10, fps: 6 },
  canteen_fridge_cake_1: { width: 1, height: 3, frames: 12, fps: 6 },
  canteen_fridge_cake_2: { width: 1, height: 3, frames: 12, fps: 6 },
  canteen_fridge_cake_3: { width: 1, height: 3, frames: 12, fps: 6 },
  canteen_fridge_empty: { width: 1, height: 3, frames: 12, fps: 6 },
  cat: { width: 3, height: 1, frames: 12, fps: 10 },
  chimney: { width: 2, height: 3, frames: 3, fps: 10 },
  chimney_red: { width: 2, height: 3, frames: 3, fps: 10 },
  chimney_white: { width: 2, height: 3, frames: 3, fps: 10 },
  chimney_yellow: { width: 2, height: 3, frames: 3, fps: 10 },
  christmas_carousel: { width: 1, height: 2, frames: 16, fps: 10 },
  christmas_chimney: { width: 2, height: 3, frames: 4, fps: 10 },
  christmas_jack_in_the_box: { width: 1, height: 2, frames: 12, fps: 5 },
  christmas_snowball_globe: { width: 1, height: 1, frames: 8, fps: 10 },
  christmas_tree_lights: { width: 2, height: 3, frames: 6, fps: 3 },
  clothing_store_advertising_monitor: { width: 1, height: 3, frames: 57, fps: 8 },
  control_room_facebook_scrolling: { width: 1, height: 2, frames: 12, fps: 10 },
  control_room_screens: { width: 4, height: 3, frames: 11, fps: 10 },
  door_1: { width: 1, height: 2, frames: 5, fps: 6 },
  door_1_locked: { width: 1, height: 2, frames: 4, fps: 5 },
  door_2: { width: 1, height: 2, frames: 5, fps: 6 },
  door_3: { width: 1, height: 2, frames: 5, fps: 6 },
  door_3_locked: { width: 1, height: 2, frames: 4, fps: 5 },
  door_4: { width: 1, height: 2, frames: 5, fps: 6 },
  door_4_locked: { width: 1, height: 2, frames: 4, fps: 5 },
  door_5: { width: 1, height: 2, frames: 5, fps: 6 },
  door_5_locked: { width: 1, height: 2, frames: 4, fps: 5 },
  door_6: { width: 1, height: 2, frames: 5, fps: 6 },
  door_6_locked: { width: 1, height: 2, frames: 4, fps: 5 },
  door_bathroom: { width: 1, height: 3, frames: 5, fps: 10 },
  door_big_1: { width: 1, height: 3, frames: 5, fps: 6 },
  door_big_1_locked: { width: 1, height: 2, frames: 5, fps: 4 },
  door_big_2: { width: 1, height: 3, frames: 5, fps: 6 },
  door_big_2_locked: { width: 1, height: 2, frames: 5, fps: 4 },
  door_big_3: { width: 1, height: 3, frames: 5, fps: 6 },
  door_big_3_locked: { width: 1, height: 2, frames: 5, fps: 4 },
  door_big_4: { width: 1, height: 3, frames: 5, fps: 6 },
  door_big_4_locked: { width: 1, height: 2, frames: 5, fps: 4 },
  door_big_5: { width: 1, height: 3, frames: 5, fps: 6 },
  door_big_5_locked: { width: 1, height: 2, frames: 5, fps: 4 },
  door_big_6: { width: 1, height: 3, frames: 5, fps: 6 },
  door_big_6_locked: { width: 1, height: 2, frames: 5, fps: 4 },
  door_condominium: { width: 3, height: 2, frames: 14, fps: 6 },
  door_condominium_2: { width: 3, height: 2, frames: 14, fps: 6 },
  door_glass_double: { width: 2, height: 3, frames: 8, fps: 5 },
  door_glass_left: { width: 1, height: 3, frames: 8, fps: 5 },
  door_glass_right: { width: 1, height: 3, frames: 8, fps: 5 },
  door_glass_sliding: { width: 2, height: 2, frames: 14, fps: 6 },
  door_glass_vertical_left: { width: 2, height: 3, frames: 8, fps: 5 },
  door_glass_vertical_right: { width: 2, height: 3, frames: 8, fps: 5 },
  door_prison: { width: 1, height: 3, frames: 8, fps: 5 },
  door_prison_cell: { width: 1, height: 3, frames: 8, fps: 5 },
  door_vertical_left_1: { width: 2, height: 3, frames: 8, fps: 5 },
  door_vertical_left_2: { width: 2, height: 3, frames: 8, fps: 5 },
  door_vertical_left_3: { width: 2, height: 3, frames: 8, fps: 5 },
  door_vertical_right_1: { width: 2, height: 3, frames: 8, fps: 5 },
  door_vertical_right_2: { width: 2, height: 3, frames: 8, fps: 5 },
  door_vertical_right_3: { width: 2, height: 3, frames: 8, fps: 5 },
  elevator_door_entrance_1: { width: 2, height: 2, frames: 14, fps: 6 },
  elevator_door_entrance_2: { width: 2, height: 2, frames: 14, fps: 6 },
  elevator_door_exit: { width: 2, height: 1, frames: 16, fps: 7 },
  emergency_exit: { width: 1, height: 3, frames: 5, fps: 4 },
  escalator_down: { width: 3, height: 5, frames: 6, fps: 10 },
  escalator_up: { width: 3, height: 5, frames: 6, fps: 10 },
  fishcuttingtable_sink: { width: 3, height: 2, frames: 4, fps: 10 },
  fishmonger_fish_tank: { width: 3, height: 3, frames: 6, fps: 10 },
  fishmonger_sink: { width: 1, height: 3, frames: 14, fps: 8 },
  fitting_room_curtain: { width: 2, height: 2, frames: 14, fps: 6 },
  floating_floor_generic_middle: { width: 1, height: 2, frames: 12, fps: 6 },
  floating_floor_left: { width: 1, height: 2, frames: 12, fps: 6 },
  floating_floor_middle: { width: 1, height: 2, frames: 12, fps: 6 },
  floating_floor_right: { width: 1, height: 2, frames: 12, fps: 6 },
  fridge_grey_vertical_left: { width: 2, height: 3, frames: 8, fps: 5 },
  fridge_grey_vertical_right: { width: 2, height: 3, frames: 8, fps: 5 },
  fridge_white_vertical_left: { width: 2, height: 3, frames: 8, fps: 5 },
  fridge_white_vertical_right: { width: 2, height: 3, frames: 8, fps: 5 },
  frog_2_idle: { width: 1, height: 1, frames: 6, fps: 10 },
  frog_3_idle: { width: 1, height: 1, frames: 6, fps: 10 },
  frog_4_idle: { width: 1, height: 1, frames: 6, fps: 10 },
  frog_idle: { width: 1, height: 1, frames: 6, fps: 10 },
  glowing_pumpkin: { width: 1, height: 2, frames: 8, fps: 10 },
  grocery_store_bakery_industrial_fridge_both: { width: 2, height: 3, frames: 6, fps: 4 },
  grocery_store_bakery_industrial_fridge_left: { width: 2, height: 3, frames: 6, fps: 4 },
  grocery_store_bakery_industrial_fridge_right: { width: 2, height: 3, frames: 6, fps: 4 },
  grocery_store_bakery_industrial_oven_down: { width: 2, height: 3, frames: 4, fps: 3 },
  grocery_store_bakery_industrial_oven_up: { width: 2, height: 3, frames: 4, fps: 3 },
  grocery_store_butchershop_carcass: { width: 1, height: 3, frames: 7, fps: 10 },
  grocery_store_butchershop_carcass_stale: { width: 1, height: 3, frames: 12, fps: 10 },
  grocery_store_butchershop_cool_room_door: { width: 1, height: 3, frames: 8, fps: 5 },
  grocery_store_checkout_roller: { width: 1, height: 1, frames: 3, fps: 10 },
  grocery_store_fridge2_glass_left: { width: 2, height: 1, frames: 10, fps: 6 },
  grocery_store_fridge2_glass_right: { width: 2, height: 1, frames: 10, fps: 6 },
  grocery_store_fridge_glass_both: { width: 2, height: 2, frames: 8, fps: 5 },
  grocery_store_fridge_glass_left: { width: 2, height: 2, frames: 8, fps: 5 },
  grocery_store_fridge_glass_right: { width: 2, height: 2, frames: 8, fps: 5 },
  grocery_store_ticket_machine: { width: 1, height: 2, frames: 6, fps: 10 },
  haunted_bookcase: { width: 5, height: 4, frames: 24, fps: 10 },
  haunted_doll_painting_1: { width: 1, height: 2, frames: 18, fps: 10 },
  haunted_doll_painting_2: { width: 1, height: 2, frames: 18, fps: 10 },
  haunted_doll_painting_3: { width: 1, height: 2, frames: 12, fps: 10 },
  haunted_mirror: { width: 1, height: 2, frames: 12, fps: 10 },
  haunted_mirror_2: { width: 1, height: 2, frames: 18, fps: 10 },
  hospital_door_blue: { width: 2, height: 3, frames: 10, fps: 6 },
  hospital_door_green: { width: 2, height: 3, frames: 10, fps: 6 },
  hospital_door_green_double: { width: 2, height: 3, frames: 10, fps: 6 },
  hospital_glass_door: { width: 1, height: 3, frames: 10, fps: 6 },
  hospital_resonance_machine: { width: 2, height: 4, frames: 14, fps: 6 },
  hospital_sink_4_7_loop: { width: 2, height: 3, frames: 9, fps: 7 },
  hospital_surgery_door: { width: 2, height: 3, frames: 10, fps: 6 },
  hospital_xraycabin_door: { width: 1, height: 3, frames: 10, fps: 6 },
  hospital_xraycabin_door_2: { width: 1, height: 3, frames: 10, fps: 6 },
  hospital_xraymachine: { width: 3, height: 3, frames: 21, fps: 10 },
  hospital_xraymachine_screen: { width: 3, height: 3, frames: 3, fps: 10 },
  hospital_xrayscreen_arm: { width: 1, height: 3, frames: 8, fps: 10 },
  hospital_xrayscreen_head: { width: 1, height: 3, frames: 12, fps: 10 },
  iron_cage: { width: 2, height: 3, frames: 5, fps: 4 },
  iron_cage_dol_32x32l: { width: 2, height: 3, frames: 5, fps: 4 },
  jail_locker_empty: { width: 1, height: 2, frames: 10, fps: 6 },
  jail_locker_full: { width: 1, height: 2, frames: 10, fps: 6 },
  jail_shower_4_8_loop: { width: 1, height: 3, frames: 11, fps: 7 },
  japanese_shrine: { width: 3, height: 3, frames: 8, fps: 5 },
  japanese_sliding_door: { width: 2, height: 2, frames: 20, fps: 7 },
  kitchen_bbq: { width: 3, height: 3, frames: 6, fps: 10 },
  kitchen_drawer_1: { width: 1, height: 1, frames: 6, fps: 4 },
  kitchen_drawer_2: { width: 1, height: 1, frames: 6, fps: 4 },
  kitchen_drawer_3: { width: 1, height: 1, frames: 6, fps: 4 },
  kitchen_kneader: { width: 2, height: 2, frames: 4, fps: 10 },
  kitchen_oven: { width: 1, height: 2, frames: 6, fps: 4 },
  kitchen_oven_1cooker: { width: 1, height: 1, frames: 4, fps: 10 },
  kitchen_oven_2cookers: { width: 1, height: 1, frames: 4, fps: 10 },
  kitchen_oven_3cookers: { width: 1, height: 1, frames: 4, fps: 10 },
  kitchen_oven_4cookers: { width: 1, height: 1, frames: 4, fps: 10 },
  kitchen_pan_with_omelette: { width: 2, height: 2, frames: 8, fps: 10 },
  kitchen_sink_1: { width: 2, height: 1, frames: 3, fps: 10 },
  kitchen_sink_2: { width: 2, height: 1, frames: 3, fps: 10 },
  kitchen_sink_3: { width: 2, height: 1, frames: 3, fps: 10 },
  mirror_person_approaching_3: { width: 1, height: 2, frames: 8, fps: 5 },
  mirror_person_approaching_4: { width: 1, height: 2, frames: 8, fps: 5 },
  moldy_fruit_basket: { width: 1, height: 2, frames: 12, fps: 10 },
  morgue_freezer_door_empty: { width: 2, height: 4, frames: 10, fps: 6 },
  morgue_freezer_door_no_corpse: { width: 2, height: 4, frames: 16, fps: 7 },
  museum_laser_front: { width: 1, height: 2, frames: 7, fps: 10 },
  museum_laser_front_modular: { width: 1, height: 1, frames: 7, fps: 10 },
  museum_laser_horizontal: { width: 2, height: 1, frames: 7, fps: 10 },
  museum_laser_horizontal_modular: { width: 1, height: 1, frames: 7, fps: 10 },
  museum_ticket_office_door_back: { width: 1, height: 3, frames: 12, fps: 6 },
  museum_ticket_office_door_front: { width: 1, height: 3, frames: 12, fps: 6 },
  museum_ticket_turnstile: { width: 2, height: 3, frames: 8, fps: 5 },
  museum_ticket_turnstile_vertical: { width: 2, height: 3, frames: 8, fps: 5 },
  old_tv2: { width: 2, height: 2, frames: 6, fps: 10 },
  party_balloon_blue: { width: 1, height: 2, frames: 5, fps: 10 },
  party_balloon_green: { width: 1, height: 2, frames: 5, fps: 10 },
  party_balloon_red: { width: 1, height: 2, frames: 5, fps: 10 },
  party_balloon_yellow: { width: 1, height: 2, frames: 5, fps: 10 },
  pentacle: { width: 1, height: 2, frames: 12, fps: 10 },
  public_toilet_door: { width: 1, height: 3, frames: 8, fps: 5 },
  punching_bag_left: { width: 2, height: 2, frames: 6, fps: 10 },
  punching_bag_left_2: { width: 2, height: 2, frames: 6, fps: 10 },
  punching_bag_left_3: { width: 2, height: 2, frames: 6, fps: 10 },
  punching_bag_right: { width: 2, height: 2, frames: 6, fps: 10 },
  punching_bag_right_2: { width: 2, height: 2, frames: 6, fps: 10 },
  punching_bag_right_3: { width: 2, height: 2, frames: 6, fps: 10 },
  receptionist_2: { width: 1, height: 2, frames: 7, fps: 10 },
  receptionist_2_with_textbox: { width: 2, height: 3, frames: 7, fps: 10 },
  receptionist_with_textbox: { width: 2, height: 3, frames: 7, fps: 10 },
  safe_bucks: { width: 1, height: 2, frames: 6, fps: 10 },
  safe_gold: { width: 1, height: 2, frames: 6, fps: 10 },
  security_camera_left: { width: 1, height: 1, frames: 10, fps: 6 },
  security_camera_right: { width: 1, height: 1, frames: 10, fps: 6 },
  security_camera_wall_right: { width: 1, height: 1, frames: 10, fps: 6 },
  shopping_cart_blue_empty_down: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_blue_empty_left: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_blue_empty_right: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_blue_empty_up: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_blue_full1_down: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_blue_full1_left: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_blue_full1_right: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_blue_full1_up: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_blue_full2_down: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_blue_full2_left: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_blue_full2_right: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_blue_full2_up: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_blue_full3_down: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_blue_full3_left: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_blue_full3_right: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_blue_full3_up: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_green_empty_down: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_green_empty_left: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_green_empty_right: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_green_full1_down: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_green_full1_left: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_green_full1_right: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_green_full1_up: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_green_full2_down: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_green_full2_left: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_green_full2_right: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_green_full2_up: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_green_full3_down: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_green_full3_left: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_green_full3_right: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_green_full3_up: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_red_empty_down: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_red_empty_left: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_red_empty_right: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_red_empty_up: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_red_full1_down: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_red_full1_right: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_red_full1_up: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_red_full2_down: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_red_full2_left: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_red_full2_right: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_red_full2_up: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_red_full3_down: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_red_full3_left: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_red_full3_right: { width: 2, height: 2, frames: 3, fps: 10 },
  shopping_cart_red_full3_up: { width: 2, height: 2, frames: 3, fps: 10 },
  sink: { width: 2, height: 2, frames: 3, fps: 10 },
  spell_book: { width: 2, height: 2, frames: 36, fps: 10 },
  spider: { width: 1, height: 2, frames: 8, fps: 10 },
  sprout: { width: 1, height: 2, frames: 4, fps: 10 },
  tapis_roulant: { width: 2, height: 3, frames: 12, fps: 10 },
  toybox_2_full: { width: 1, height: 2, frames: 12, fps: 6 },
  toybox_empty: { width: 1, height: 2, frames: 12, fps: 6 },
  toybox_empty_2: { width: 1, height: 2, frames: 12, fps: 6 },
  toybox_full: { width: 1, height: 2, frames: 12, fps: 6 },
  toytrain: { width: 6, height: 4, frames: 35, fps: 10 },
  trap_falling_blade: { width: 1, height: 2, frames: 12, fps: 10 },
  trap_falling_bookcase: { width: 2, height: 5, frames: 11, fps: 6 },
  trap_flipping_floor: { width: 1, height: 1, frames: 10, fps: 5 },
  trap_flipping_floor_generic: { width: 1, height: 1, frames: 10, fps: 5 },
  trap_flipping_floor_generic_wall: { width: 1, height: 1, frames: 10, fps: 5 },
  trap_flipping_floor_wall: { width: 1, height: 1, frames: 10, fps: 5 },
  trapdoor_1: { width: 1, height: 1, frames: 6, fps: 4 },
  trapdoor_2: { width: 1, height: 1, frames: 6, fps: 4 },
  trapdoor_3: { width: 1, height: 1, frames: 6, fps: 4 },
  treadmill: { width: 3, height: 4, frames: 3, fps: 10 },
  tv_reportage: { width: 3, height: 2, frames: 24, fps: 10 },
  tv_reportage_hospital: { width: 3, height: 2, frames: 24, fps: 10 },
  tv_reportage_hospital_2: { width: 3, height: 2, frames: 24, fps: 10 },
  wall_piano: { width: 2, height: 2, frames: 8, fps: 5 },
  wall_piano_2: { width: 2, height: 2, frames: 8, fps: 5 },
  wall_piano_3: { width: 2, height: 2, frames: 8, fps: 5 },
  wall_piano_4: { width: 2, height: 2, frames: 8, fps: 5 },
  witch_cauldron: { width: 2, height: 2, frames: 12, fps: 10 },
};
